import { createAction } from 'redux-actions';

export const showNotification = createAction('SHOW_NOTIFICATION');
export const hideNotification = createAction(
  'HIDE_NOTIFICATION',
  removeDelay =>
    new Promise(resolve => {
      setTimeout(() => resolve(), removeDelay);
    })
);



// WEBPACK FOOTER //
// ./src/actions/notification_actions.js